import { useLocalStorage } from '@vueuse/core'
import type { RouteLocationNormalized } from 'vue-router'

export declare interface RecentPage {
    name: string
    path: string
    title: string
    icon: string
    id?: string
}

const STORAGE_KEY = 'prophet.recentPages'
const MAX_RECENT = 6

const recentPages = useLocalStorage<RecentPage[]>(STORAGE_KEY, [])

/**
 * Reactive list of the most recently visited pages, persisted on the device.
 * Most recent page is first.
 */
export function useRecentPages() {
    return recentPages
}

/**
 * Record a route as a recently visited page. Only navigable pages that expose
 * a title and an icon are kept, and the home page itself is excluded.
 */
export function recordRecentPage(route: RouteLocationNormalized) {
    const meta = route.meta
    if (!meta?.icon || !meta?.title) return
    if (meta.id === 'acceuil') return

    const name = route.name ? String(route.name) : ''
    if (!name) return

    const entry: RecentPage = {
        name,
        path: route.path,
        title: String(meta.title),
        icon: String(meta.icon),
        id: meta.id ? String(meta.id) : undefined,
    }

    const list = recentPages.value.filter(
        (p) => p.name !== entry.name && p.path !== entry.path,
    )
    list.unshift(entry)
    recentPages.value = list.slice(0, MAX_RECENT)
}
